import { render, staticRenderFns } from "./host-product.vue?vue&type=template&id=281f4001&scoped=true&"
import script from "./host-product.vue?vue&type=script&lang=js&"
export * from "./host-product.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "281f4001",
  null
  
)

export default component.exports